import { useEffect, useMemo, useRef, useState } from 'react';

export function useTheme() {
  const [stored, setStored] = useState(() => {
    try {
      return localStorage.getItem('theme'); // 'light' | 'dark' | null
    } catch {
      return null;
    }
  });

  const mediaQuery = useMemo(() => window.matchMedia('(prefers-color-scheme: dark)'), []);
  const [systemIsDark, setSystemIsDark] = useState(mediaQuery.matches);
  const initialized = useRef(false);

  useEffect(() => {
    const listener = (e) => setSystemIsDark(e.matches);
    mediaQuery.addEventListener?.('change', listener);
    return () => mediaQuery.removeEventListener?.('change', listener);
  }, [mediaQuery]);

  const theme = stored ?? (systemIsDark ? 'dark' : 'light');

  useEffect(() => {
    const root = document.documentElement;
    root.classList.toggle('dark', theme === 'dark');
    root.style.colorScheme = theme;
    if (initialized.current) return;
    initialized.current = true;
  }, [theme]);

  const toggleTheme = () => {
    const next = theme === 'dark' ? 'light' : 'dark';
    setStored(() => {
      try { localStorage.setItem('theme', next); } catch {}
      return next;
    });
  };

  const clearPreference = () => {
    try { localStorage.removeItem('theme'); } catch {}
    setStored(null);
  };

  return { theme, toggleTheme, clearPreference };
}
